import { render, staticRenderFns } from "./profil_sekda.vue?vue&type=template&id=87cb90a0&"
import script from "./profil_sekda.vue?vue&type=script&lang=js&"
export * from "./profil_sekda.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports